<app-dialog [size]="dialogSize">
  <app-dialog-header>Resend Invoice {{ data.invoiceNumber }}</app-dialog-header>

  <div class="w-6">
    <div *ngIf="isLoading$ | async" class="d-flex justify-content-center w-100 mb-4 mt-2">
      <mat-spinner color="white" diameter="90" />
    </div>

    <div *ngIf="errors$ | async as errorMsg" class="alert alert--error w-100">
      {{ errorMsg }}
    </div>

    <ng-container *ngIf="emailRecipientsVm$ | async as emails">
      <app-recipient-emails
        class="mb-4 mt-2"
        [additionalEmails]="(emails | slice: 1 : emails.length + 1) || []"
        [primaryEmail]="emails[0] || ''"
        (isValid)="setSubmitBtnValidity($event)"
      />
    </ng-container>
  </div>

  <app-dialog-footer>
    <button type="button" [disabled]="submitBtnEnabled" [isLoading]="isSending$ | async" (click)="submit()" andButton color="primary">
      Resend
    </button>
  </app-dialog-footer>
</app-dialog>
